<template>
  <v-app>
    <Sidebar />

    <v-app-bar app flat clipped-left>
      <v-app-bar-nav-icon @click.stop="$root.drawer = !$root.drawer" />
      <v-toolbar-title class="text-button">
        {{ $root.appTitle }}
      </v-toolbar-title>
      <div style="width='150px'" class="pl-4">
        <v-select
          v-if="$page.props.jetstream.hasTeamFeatures"
          v-model="team"
          dense
          :hide-details="true"
          label="Ansicht"
          :items="chooseableTeams"
          item-text="name"
          item-value="id"
          :menu-props="{ closeOnContentClick: false}"
          @change="switchTeam"
        />
      </div>
      <v-spacer />
      <span class="ml-3" style=" text-transform: uppercase;">
        {{ address }} {{ user.name }}
      </span>
      <v-spacer />
      <span>
        {{ date }} {{ time }}
      </span>
      <v-img contain src="/img/T_logo.png" height="39px" max-width="200px" />

      <v-img
        contain
        src="/img/logo_nwt_new.png"
        height="56px"
        max-width="200px"
      />
      <v-toolbar-items>
        <!-- <NotificationsMenu /> -->
        <UserMenu />
      </v-toolbar-items>
    </v-app-bar>
    <v-main class="background">
      <v-breadcrumbs v-if="$page.props.breadcrumbs" :items="$page.props.breadcrumbs" />
      <flash-messages />
      <tabbar />
      <slot />
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import Sidebar from '@/Components/Layout/Sidebar'
import Tabbar from '@/Components/Layout/Tabbar'
import Footer from '@/Components/Layout/Footer'

export default {
   name: 'MainLayout',
   components: {
      Sidebar,
      Tabbar,
      Footer,
   },
   data: () => ({
      //   drawer: false,
      team: null,
      user: null,
      time: null,
      date: (new Date()).toLocaleDateString('de-De')
   }),
   computed: {
      chooseableTeams () {
         return Object.values(this.$page.props.user.all_teams).filter(team => (team.user_id === this.user.id || (team.membership && (team.membership.role === 'admin' || team.membership.role === 'team_leader' || team.membership.role === 'hunter' || team.membership.role === 'personal.replacement'))))
      },
      address () {
         let curTime = new Date()
         curTime = parseInt(curTime.getHours() + '' + ('0' + curTime.getMinutes()).substr(-2))

         if (curTime < 1200) return 'Guten Morgen'
         else if (curTime < 1800) return 'Guten Tag'
         else return 'Guten Abend'
      }
   },
   created () {
      this.user = this.$page.props.user
      this.team = this.$page.props.user.current_team_id
   },
   mounted () {
      setInterval(() => {
         const localDate = new Date()
         this.time = localDate.toLocaleTimeString('de-DE')
      }, 1000)
   },
   methods: {
      switchTeam () {
         this.$inertia.put(this.route('current-team.update'), {
            team_id: this.team
         }, {
            preserveState: true
         })
      }
   }
}
</script>
